/* Component Dependencies */
var groupFormCTATemplate = require('templates/groupFormCTA.hbs');
var groupReservationContinueCtaTemplate = require('templates/groupReservationContinueCta.hbs');
var AriesComponent = require('libs/aries-component');
var Popup = require('libs/popup');
var getPath = window.location.pathname;
var getEventURL = getPath.includes("event-profile");
var _ = require('lodash');
var submitRFPLink;
AriesComponent.create({
  type: 'groupFormCTA',
  template: {
    'groupFormCTA': groupFormCTATemplate,
    'groupReservationContinueCta': groupReservationContinueCtaTemplate
  },

  config: {
    data: {}
  },
  subscribe: {
    'UPDATE_FORM_DATA': 'updateFormSubmitData',
    'SHOW_SKIP_TO_CONTACT_CTA': 'showSkipToContactInfoCTA',
    'ENABLE_CONTINUE_BILLING_CONTACT': 'toggleContinueButton',
    'QG_DISABLE_CONTINUE_BTN': 'disableContinueBtn',
	  'QG_HIDE_CONTINUE_BTN': 'hideContinueBtn',
    'RFP_FORM_SUBMIT': 'submitForm',
    'FROM_IFRAME_CC_LOADED': 'setCCLoadHandler',
    'FROM_IFRAME_SET_CC_DATA': 'setCCFrameData',
  },
  creditCardFrame: {
    isLoaded: false,
    isDataReceived: false,
  },
	 ctaSelector: '.js-submit-finalize',
  events: {
    'click .js-submit-bttn': 'submitFormData',
    'click .js-finalize-form-submit': 'submitReservationContinue',
    'click .js-submit-once': 'submitRfpOnce'
  },
  bindEvents: function() {
    var _self = this;
    _self.hasIframeFormFields = _self.$el.data('hasIframeFormFields');
    if(_self.hasIframeFormFields){
      _self.pubsub.publish('QG_FORM_LOADED');
    }
    _self.showPopup();
    _self.handleTabIndex();
    _self.formElement = _self.$el.parents('form');
    submitRFPLink = $('.submit-rfp-link').val()
  },
  /**
   * This method will update form data object.
   * @param {string} it expects key to wrap the json object.
   * @param {object} it contains the data i.e key is name of input field and value is val of input field.
   */
  updateFormSubmitData: function _updateFormSubmitData(key, formData) {
    var _self = this;
    _self.config.data[key] = formData;
  },
  /**
   * This method will submit data using ajax.
   * @event {object} click event of submit button
   */
  submitFormData: function _submitFormData(event) {
    event.stopPropagation();
    var _self = this,
      ele = $(event.target),
      isSkipToContactInfo = false,
      isQuickGroupApplicable = false,
      endpoint = ele.data('endpoint');
    if (ele.attr('name') === 'skipToContactCTA') {
      isSkipToContactInfo = true;
    }
    _self.config.data.isSkipToContactInfo = isSkipToContactInfo;
    _self.config.data.isQuickGroupApplicable = _self.$el.find("input[name='isQuickGroupApplicable']").val();

    _self.makeAjaxCall({
      url: endpoint,
      method: 'POST',
      data: JSON.stringify(_self.config.data),
      contentType: 'application/json',
      success: function(response) {
        if (response.isError === true) {
          //error tile refresh
        }
        if(response.showOverlay){
          _self.showQuickGroupOverlay();
        }
        if(response.status === "success" && !getEventURL) {
          var pathName = _.escape(submitRFPLink);
          var originloc = _.escape(window.location.origin);
          if (originloc) {
            window.location.href = originloc + pathName;
          }
        }
      },
      error: function() {
          var pathName = _.escape(submitRFPLink);
          var originloc = _.escape(window.location.origin);
          if (originloc) {
            window.location.href = originloc + pathName;
          }
      }
    });
  },
  /**
   * This method will show and hide skip to contact CTA 
   * @param {object} contains the show and hide flag for skip to contact CTA.
   */
  showSkipToContactInfoCTA: function _showSkipToContactInfoCTA(data) {
    var _self = this,
    $skipContactButton = _self.$el.find('.js-skip-to-contact-bttn');
    if (data && data.show) {
      $skipContactButton.removeClass('is-hidden').closest('div').addClass('l-s-margin-top-five-quarters');
    } else {
      $skipContactButton.addClass('is-hidden').closest('div').removeClass('l-s-margin-top-five-quarters');

    }
  },
  /**
   * This method will open login overlay based on flag
   */
  showPopup: function() {
    if (this.$el.find('button[data-popupurl]').data('showpopup')) {
      var signIn = new Popup({
        url: this.$el.find('button[data-popupurl]').data('popupurl'),
        open: true, 
        alternateCloseMarkup: true,
        sourceBlock: '.modal-content',
      });
      signIn.register();
    }
  },
  handleTabIndex: function() {
    this.$el.find('.m-button').attr('tabIndex', 0);
  },
  showQuickGroupOverlay: function(){ 
      var _self = this;
      var quickGroup = new Popup({
        url: _self.$el.find('button[data-overlayurl]').data('overlayurl'),
        open: true, 
        alternateCloseMarkup: true,
        sourceBlock: '.modal-content',
        afterClose:function(){
          window.location.href = _self.$el.find('button[data-redirecturl]').data('redirecturl');
        }
      });
      quickGroup.register();
  },
  toggleContinueButton : function(event){
    var _self = this;
    if(event){
      _self.$el.find('.js-continue-btn').removeClass('is-disabled');
      _self.$el.find('.js-continue-btn').removeAttr('disabled');
    }else{
      _self.$el.find('.js-continue-btn').addClass('is-disabled');
      _self.$el.find('.js-continue-btn').prop('disabled', true);
    }
  },
		/**
			* Suppress Continue and Submit Inquiry CTA if any critical tile is not rendered on page.
			* @return {void}
			*/
		disableContinueBtn: function () {
				var _self = this;
			_self.$el.find('.js-finalize-form-submit')
			.addClass('is-disabled')
			.prop('disabled', true);
			_self.pubsub.publish('QG_CONTINUE_BTN_DISABLED');
		},

		/**
			* Hide Continue and Submit Inquiry CTA if any critical tile is not rendered on page.
			* @return {void}
			*/
		hideContinueBtn: function () {
			var _self = this;
			_self.$el.addClass('l-display-none');
			_self.pubsub.publish('QG_CONTINUE_BTN_HIDDEN');
		},

  submitForm: function (selector) { 
    var _self = this;
   _self.$el.find(selector).removeAttr('disabled').trigger( "click" );
  },

  submitReservationContinue : function(event) {
    event.preventDefault();
    var _self = this;
    var currentVal = $(event.target).attr('data-name');
    var  actionU =  $(event.target).attr('data-url');
    if(_self.hasIframeFormFields && !_self.hasCCFormData(event)) {
      return false;
    }
    _self.disableContinueBtn();
    $('.l-hidden-field').val('');
    $('input[name="'+currentVal +'"]').val(true);
    $('form').attr('action', actionU);
    $('form').submit();
    $(actionUrl).hide();
  },

  submitRfpOnce : function(event) {
    event.preventDefault();
    var _self = this;
    _self.$el.find('.js-submit-once')
    .addClass('is-disabled')
    .prop('disabled', true);
    _self.formElement.submit();
  },

  /**
   * This method sets the cc loaded flag
   * @method setCCLoadHandler
   * @return {void}
   */
  setCCLoadHandler: function _setCCLoadHandler() {
    this.creditCardFrame.isLoaded = true;
  },

  /**
   * This method submits the form with the fetched credit card data from Iframe
   * @param {Object} ccFormData form data object of credit card frame
   * @method setCCFrameData
   */
  setCCFrameData: function _setCCFrameData(ccFormData) {
    var _self = this;
    var dataToAppend = '';
    Object.keys(ccFormData).forEach(function(key) {
      dataToAppend += '<input type="hidden" name="' + key + '" value="' + ccFormData[key] + '"/>';
    });
    _self.$el.append(dataToAppend);
    _self.creditCardFrame.isDataReceived = true;
    _self.submitForm(_self.ctaSelector);
  },

  hasCCFormData: function _hasCCFormData(event) {
    var _self = this, $target = $(event.currentTarget);
    if(_self.creditCardFrame.isLoaded && !this.creditCardFrame.isDataReceived) {
      _self.pubsub.publish('TO_IFRAME_GET_CC_DATA');
      if($target.hasClass('js-submit-finalize')) {
							 _self.ctaSelector = '.js-submit-finalize';
						} else {
							 _self.ctaSelector = '.js-submit-inquiry';
						}
    }
    return _self.creditCardFrame.isDataReceived;
  }
});
